<template>
  <data-section
    style="font-size: 15px"
    theme="red"
    title="商品建議書"
    :datas="datas"
    :_fields="dataFields"
    @toggle="(isShow) => $router.assignQuery({ ProductSuggestShow: isShow })"
    :initShow="$route.query['ProductSuggestShow'] !== 'false'"
  >
    <template scope="props"  v-if="refresh">
      <!--<button
        v-if="isSelectable"
        type="button"
        class="btn btn-default btn-sm m-0 mt-2"
        @click="clearSelectedProduct"
      >
        清空所有保單
      </button>-->
      <section
        v-for="(person, index) in props.datas.filter((x) =>
          allFamily.includes(x.insuredpersonid)
        )"
        :key="'other' + index"
        class="newTable"
      >
        <data-table
        :isSelectable="isSelectable"
          v-bind="
            Object.assign({}, props, {
              datas: proccessDatas(person)
            })
          "
          @changeSort="
            (sort) =>
              $router.assignQuery({
                [`ProductSuggestSort${index}`]: JSON.stringify(sort)
              })
          "
          :initSort="
            $route.query[`ProductSuggestSort${index}`]
              ? JSON.parse($route.query[`ProductSuggestSort${index}`])
              : {}
          "
        >
          <template slot="thead">
            <thead class="thBorderCustSuggest" style="background-color: white ;background-color: rgb(250, 250, 225);">
              <tr>
                <th
                 class="thBorderCustSuggest"
                 style="
                  border: #de4054 1px solid" 
                  :colspan="isSelectable ? 10 : 9">
                  <div class="font-20 text-center text-black position-relative">
                    <span v-if="isSelectable" class="checkbox m-0 select-all">
                      <input
                        type="checkbox"
                        :id="`customerSuggest${person.insuredpersonid}`"
                        :value="person.insuredpersonid"
                        v-model="checkAllList"
                        @change="checkAll(person)"
                      />
                      <label :for="`customerSuggest${person.insuredpersonid}`">全選</label>
                    </span>
                      <strong>
                        {{ headerLabel }}：
                        <avatar
                          class="mr-2 mt-1"
                          :gender="
                            Number(person.insuredpersonsex == 'Female' ? 2 : 1)
                          "
                          :size="20"
                        />
                        </strong>
                        <!-- 20210624 個資遮蔽 -->
                        <Tooltip
                          position="top"
                          :id="person.insuredpersonid && !person.insuredpersonid.includes('~')?person.insuredpersonid:''"
                          :birthday="person.insuredpersonbirthday?person.insuredpersonbirthday:''"
                          style="font-size:16px;font-weight: 500;"
                        >
                          <strong
                            @click="routeToCustDetail(person.insuredpersonid , person.insuredpersonname )"
                            class="link text-underline"
                            style="font-size:20px;"
                          >
                            {{ person.insuredpersonname | truncate}}
                          </strong>
                        </Tooltip>
                    <strong class="ml-3">年齡：</strong>
                    <span class="fw-normal">
                      {{
                        person.insuredpersonage
                          ? person.insuredpersonage
                          : person.insuredpersonbirthday
                          ? moment().diff(
                              person.insuredpersonbirthday,
                              "years"
                            )
                          : "一一"
                      }}歲 ({{
                        person.insuredpersonbirthday
                          ? moment(person.insuredpersonbirthday).getROCDate()
                          : "一一" | getMaskBirthday
                      }})
                    </span>
                    <strong class="ml-3">身分證：</strong>
                    <span class="fw-normal">
                      {{
                        person.insuredpersonid.includes("~")
                          ? "一一"
                          : person.insuredpersonid
                          | getMaskID
                      }}</span
                    >
                  </div>
                </th>
              </tr>
            </thead>
          </template>
          <template slot="productselect" scope="item">
            <span 
            v-if="item.data.isPrimaryContract || item.data.isPureSubContract" 
              class="checkbox m-0"
            >
              <input
                type="checkbox"
                :id="getProductLabelId(item)"
                :value="getProductLabelId(item)"
                v-model="checkedList"
                @change="checkProduct"
              />
              <label :for="getProductLabelId(item)"></label>
            </span>
          </template>
          <template slot="productname" scope="item">
            <div v-if="item.data.isprimarycontract">
              <div class="font-13">
                  商品建議書
              </div>        
              <div>
                {{ item.data.productname }}
                {{ item.data.prodid ? `(${item.data.prodid})` : "" }}
              </div>
            </div>
            <div v-else>
              <div style="margin-left: 1em; text-indent: -1em">
                <span style="text-shadow: 0px 1px grey" class="text-gray">
                  <strong>└</strong>
                </span>
                {{ item.data.productname }}
                {{ item.data.prodid ? `(${item.data.prodid})` : "" }}
              </div>
            </div>
          </template>
          <template slot="applicant" scope="item">
            <span v-if="item.data.c111_apc!= ''" @click="routeToCustDetail(item.data.c111_apc , item.data.applicant )" class="link text-underline">
              {{ item.data.applicant | truncate }}
            </span>
            <div  v-else>
                {{ item.data.applicant | truncate }}
            </div>
          </template>
          <template slot="year" scope="item">
            {{
              item.data.paymentway == "躉繳"
                ? "--"
                : item.data.year.padLeft(2, "0")
            }}
            <span v-if="item.data.year_type === '2'">歲</span>
          </template>
          <template slot="amountofinsurance" scope="item">
            <div
              v-if="item.data.schemename && item.data.quantity"
              class="text-right pre-formatted"
            >
              {{
                item.data.schemename && item.data.schemename.includes("_1")
                  ? `計畫${item.data.schemename}：\n`
                  : `計畫${item.data.schemename}：\n日額`
              }}{{ `${item.data.quantity}元` }}
            </div>
            <div v-else class="text-right">
              {{ item.data.amountofinsurance }}
            </div>
          </template>
          <template slot="bknm" scope="item">
            <div v-if="item.data.premium">
              {{ item.data.money }} {{ item.data.premium | numberFormat }}
            </div>
            <div>{{ item.data.paymentway }}</div>
            <div v-if="item.data.bknm || item.data.card_acnt_no">
              {{ `${item.data.bknm}(${item.data.card_acnt_no})` }}
            </div>
          </template>
          <template slot="bnf" scope="item">
            <div
              v-for="(name, key) in {
                bnf_death_nm: '身故',
                bnf_matag_nm: '滿期',
                bnf_annuity_nm: '年金',
                bnf_birth_nm: '祝壽'
              }"
              :key="key"
            >
              <span
                v-if="item.data[key]"
                :set="(names = item.data[key].split(','))"
              >
                {{ name }}：
                <span v-for="(name, index) in names" :key="index">
                  <truncate-tool :content="name"></truncate-tool>
                  {{ names.length - 1 > index ? "、" : "" }}
                </span>
              </span>
            </div>
            <div
              v-if="
                !item.data.bnf_death_nm &&
                !item.data.bnf_matag_nm &&
                !item.data.bnf_annuity_nm &&
                !item.data.bnf_birth_nm
              "
            >
              一一
            </div>
          </template>
        </data-table>
      </section>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";
import TruncateTool from "./TruncateTool";
import Tooltip from '@/desktop/components/ToolTip';
import { mvCommonMixin } from '@/desktop/views/mv/mixins/common';

const { moment } = window;
export default {
  mixins: [InsuranceMixins, mvCommonMixin],
  components: {
    TruncateTool,
    Tooltip
  },
  //20250731全選功能
  watch: {
    selectedProduct: {
      handler(newVal) {
        if (!this.isInternalUpdate && newVal !== this.checkedList) {
          this.checkedList = Array.isArray(newVal) ? [...newVal] : [];
          this.checkAllList = this.getCheckAllList();
        }
      },
      deep: true,
      immediate: false 
    },
    isSelectAll(val) {
      if (val) {
        this.datas.forEach(person => {
          person.majorpolicyinfolist.forEach(element => {
            const value = person.insuredpersonid + "_" + element.policyid;
            if (!this.checkedList.includes(value)) {
              this.checkedList.push(value);
            }
          });
        });
      } else {
        this.checkedList = [];
      }
      this.checkAllList = this.getCheckAllList();
      this.$emit('update', this.checkedList);
    },
  },
  props: {
    //20251103
    reportView: {
      type: String,
      default: 'insured'
    },
    isSelectAll: { type: Boolean, default: false },
    selectInventInsurance: {
      type: Function,
      default: () => {
        return null;
      },
    },
    modalLoading: {
      type: Boolean,
      default: false,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
    selectedProduct: {
      type: Array,
      default: () => {
          return []
      }
    },
  },
  data() {
    return {
      allFamily: localStorage.allFamily.split(","),
      checkedList: [],
      checkAllList: [],
      isInternalUpdate: false
    };
  },
  computed: {
    //20251103
    // 動態表頭標籤
    headerLabel() {
      return this.reportView === 'applicant' ? '要保人' : '被保人';
    },
    
    // 動態欄位標籤
    relationLabel() {
      return this.reportView === 'applicant' ? '被保人' : '要保人';
    },    
    dataFields() {
      const result = this.isSelectable ? [
        {
          name: '保單\n選擇',
          key: 'productselect',
          width: 50,
          sortable: false,
          orderByMultiKey: ['sortProductname'],
          thClassName: 'text-center',
          className: 'text-center',
        },
      ] : [];
      return result.concat([
        {
          name: '險種',
          key: 'productname',
          width: 274,
          sortable: true,
          orderByMultiKey: ['sortProductname'],
          orderByMultiType: ['asc']
        },
        {
          name: this.relationLabel,
          key: 'applicant',
          width: 79,
          sortable: true,
          orderByMultiKey: ['sortApplicant'],
          orderByMultiType: ['asc']
        },
        { name: '繳費\n年期', key: 'year', width: 50 },
        {
          name: '承保\n對象',
          key: 'relation',
          width: 50,
          className: 'text-left'
        },
        {
          name: '建立日期',
          key: 'insurancedate',
          width: 70,
          className: 'text-left',
          sortable: true,
          orderByMultiKey: ['sortInsuranceADDate'],
          orderByMultiType: ['asc']
        },
        {
          name: '保額',
          key: 'amountofinsurance',
          width: 96,
          thClassName: 'text-right',
          className: 'text-right'
        },
        {
          name: '保費/繳別',
          key: 'bknm',
          width: 128,
          className: 'text-right',
          sortable: true,
          orderByMultiKey: [
            'sortBknm',
            'isprimarycontract',
            'money',
            'longPremium'
          ],
          thClassName: 'text-right',
          orderByMultiType: ['asc', 'adesc', 'asc', 'asc']
        },
        { name: '受益人', key: 'bnf', width: 144 }
      ], this._fields);
    }
  },
  methods: {
    proccessDatas(person) {
      return person.majorpolicyinfolist
        .map((primary) => {
          const primaryData = primary.policyinfolist[0];
          return primary.policyinfolist.map((data) => {
            const isPrimaryContract = !!data.isprimarycontract;
            const isPureSubContract = primary.policyinfolist.every(
              (x) => !x.isprimarycontract
            );
            const isSubContract = !isPrimaryContract && !isPureSubContract;
            return  Object.assign({}, data, {
              applicant: primary.applicant,
              c111_apc: primary.c111_apc,
              isPrimaryContract,
              isPureSubContract, 
              isSubContract,
              card_acnt_no: primary.card_acnt_no,
              targetId: person.insuredpersonid,
              bknm: primary.bknm,
              trClassName: data.isprimarycontract ? "bg-white" : "bg-gray",
              longPremium: data.premium.padLeft(20, "0"),
              sortProductname: this.mergeString(
                primaryData.productname,
                primary.policyid
              ),
              sortApplicant: this.mergeString(
                primary.applicant,
                primary.policyid
              ),
              sortInsuranceADDate: this.mergeString(
                moment(primaryData.insurancedate).getADDate(),
                primary.policyid
              ),
              sortBknm: this.mergeString(
                !primaryData.premium ? "" : "_",
                primaryData.money,
                primaryData.premium.padLeft(20, "0"),
                primary.policyid
              )
            })
          });
        })
        .flat();
    },
    getProductLabelId(item) {
      if (this.reportView === 'applicant') {
        return item.data.targetId + "_" + item.data.policyid + "_" + (item.data.c111_apc || '');
      }      
      return item.data.targetId + "_" + item.data.policyid
    },
    checkProduct() {
      this.isInternalUpdate = true;  
      this.checkAllList = this.getCheckAllList();
      this.$emit('update', this.checkedList, this.checkAllList);
      
      this.$nextTick(() => {
        setTimeout(() => {
          this.isInternalUpdate = false;
        }, 50);
      });
    },
    syncFromParent(selectedPolicyIds) {
        this.isInternalUpdate = true;
        this.checkedList = [...selectedPolicyIds];
        this.checkAllList = this.getCheckAllList();
        this.$forceUpdate();
        
        this.$nextTick(() => {
            setTimeout(() => {
                this.isInternalUpdate = false;
            }, 50);
        });
    },    
    clearSelectedProduct() {
      this.checkedList = [];
      this.checkAllList = [];
      this.$emit('update', this.checkedList);
    },
    checkAll(person) {
      this.isInternalUpdate = true;  
      
      if(this.checkAllList.includes(person.insuredpersonid)) {
        person.majorpolicyinfolist.forEach(element => {
          const value = this.reportView === 'applicant'
            ? person.insuredpersonid + "_" + element.policyid + "_" + (element.c111_apc || '')
            : person.insuredpersonid + "_" + element.policyid;
            
          if (!this.checkedList.includes(value)) {
            this.checkedList.push(value);
          }
        });
      } else {
        const result = [];
        this.checkedList.forEach(element => {
          if (!element.includes(person.insuredpersonid)) {
            result.push(element);
          }
        });
        this.checkedList = result;
      }
      this.$emit('update', this.checkedList, this.checkAllList);
      this.$nextTick(() => {
        setTimeout(() => {
          this.isInternalUpdate = false;
        }, 50);
      });
    },
    getCheckAllList() {
      const result = [];
      const count = {};
      this.checkedList.forEach(e => {
        const id = e.split("_")[0];
        if (count[id]) count[id]++;
        else count[id] = 1;
      });
      this.datas.filter((x) => !!count[x.insuredpersonid]).forEach(e => {
        count[e.insuredpersonid] 
          && e.majorpolicyinfolist.length == count[e.insuredpersonid]
          && result.push(e.insuredpersonid);
      });
      return result;
    },
  },
  mounted () {
    if (this.isSelectable) {
      if (Array.isArray(this.selectedProduct) && this.selectedProduct.length > 0) {
        this.checkedList = [...this.selectedProduct];
        this.checkAllList = this.getCheckAllList();
      }
    }
  }
};
</script>

<style scoped lang="scss">
td {
  .checkbox {
    input + label:before {
      left: -10px
    }
  }
}
.select-all {
  position: absolute;
  left: 0;
  top: 5px;
  font-size: 15px;
  font-weight: normal;
  & > label {
    line-height: 20px !important;
  }
}
</style>